import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setClaimDocuments = options =>
  call(websocketFetch, 'set_claim_documents', options);
